import store from '@/store'
import config from './config'
import util from './utils'

export function formatMsg(msg) {
    const nim = store.state.chat.nim
    if (msg.type === 'robot') {
        if (msg.content && msg.content.flag === 'bot') {
            if (msg.content.message) {
                msg.content.message = msg.content.message.map(item => {
                    switch (item.type) {
                        case 'template':
                            item.content = nim.parseRobotTemplate(item.content)
                            break
                        case 'text':
                        case 'image':
                        case 'answer':
                            break
                        default:
                            break
                    }
                    return item
                })
            }
        }
    }
    return msg
}

export function onRoamingMsgs(obj) {
    let msgs = obj.msgs
    // let msgs = obj.msgs.map(msg => {
    //   return formatMsg(msg)
    // })
    store.commit('chat/updateMsgs', msgs)
}

export function onOfflineMsgs(obj) {
    let msgs = obj.msgs
    // let msgs = obj.msgs.map(msg => {
    //   return formatMsg(msg)
    // })
    store.commit('chat/updateMsgs', msgs)
}

export function onMsg(msg) {
    // 用于在具体会话判断是否已读
    // msg.fromLocal = true;
    store.commit('chat/putMsg', msg)
    if (msg.sessionId === store.state.chat.currSessionId) {
        store.commit('chat/updateCurrSessionMsgs', {
            type: 'put',
            msg,
        })
        // 发送已读回执
        // store.dispatch('chat/sendMsgReceipt')
    }
    if (msg.type === 'notification') {
        store.dispatch('chat/onTeamNotificationMsg', msg)
    }
}

function onSendMsgDone(error, msg) {
    if (error) {
        // 被拉黑
        if (error.code === 7101) {
            msg.status = 'success'
            alert(error.message)
        } else {
            alert(error.message)
        }
    }
    onMsg(msg)
}

function sendCustomSysMsgDone(error, msg) {
    // console.log('发送' + msg.scene + '自定义系统通知' + (!error?'成功':'失败') + ', id=' + msg.idClient);
    onMsg(msg)
}

// 消息撤回
export function onRevocateMsg(error, msg) {
    const nim = store.state.chat.nim
    if (error) {
        if (error.code === 508) {
            alert('发送时间超过2分钟的消息，不能被撤回')
        } else {
            alert(error)
        }
        return
    }
    let tip = ''
    if (msg.from === store.state.chat.userUID) {
        tip = '你撤回了一条消息'
    } else {
        let userInfo = store.state.chat.userInfos[msg.from]
        if (userInfo) {
            tip = `${util.getFriendAlias(userInfo)}撤回了一条消息`
        } else {
            tip = '对方撤回了一条消息'
        }
    }
    nim.sendTipMsg({
        isLocal: true,
        scene: msg.scene,
        to: msg.to,
        tip,
        time: msg.time,
        done: function sendTipMsgDone(err, tipMsg) {
            let idClient = msg.deletedIdClient || msg.idClient
            store.commit('chat/replaceMsg', {
                sessionId: msg.sessionId,
                idClient,
                msg: tipMsg,
            })
            if (msg.sessionId === store.state.chat.currSessionId) {
                store.commit('chat/updateCurrSessionMsgs', {
                    type: 'replace',
                    idClient,
                    msg: tipMsg,
                })
            }
        },
    })
}

export function revocateMsg({state, commit}, msg) {
    const nim = state.nim
    let {idClient} = msg
    msg = Object.assign(msg, state.msgsMap[idClient])
    nim.deleteMsg({
        msg,
        done: function deleteMsgDone(error) {
            onRevocateMsg(error, msg)
        },
    })
}

// 发送普通消息
export function sendMsg({state, commit}, obj) {
    const nim = state.nim
    obj = obj || {}
    let type = obj.type || ''
    let content = {
        type: 'text',
        value: obj.text,
    }
    content = JSON.stringify(content)
    switch (type) {
        case 'text':
            nim.sendText({
                custom: obj.custom,
                scene: obj.scene,
                to: obj.to,
                text: obj.text,
                done: onSendMsgDone,
                needMsgReceipt: obj.needMsgReceipt || true,
                pushContent: obj.pushContent,
                isPushable: obj.isPushable || true,
                needPushNick: obj.needPushNick || false,
            })
            nim.sendCustomSysMsg({
                scene: obj.scene,
                to: obj.to,
                pushPayload: content,
                content,
                sendToOnlineUsersOnly: false,
                isPushable: false,
                apnsText: content,
                done: sendCustomSysMsgDone,
            })
            break
        case 'custom':
            nim.sendCustomMsg({
                scene: obj.scene,
                to: obj.to,
                pushContent: obj.pushContent,
                content: JSON.stringify(obj.content),
                done: onSendMsgDone,
            })
            break
        default:
            break
    }
}

// 发送文件消息
export function sendFileMsg({state, commit}, obj) {
    const nim = state.nim
    let {
        scene, to, custom, fileInput, needMsgReceipt, pushContent, isPushable, needPushNick,
    } = obj
    let type = 'file'
    if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(fileInput.value)) {
        type = 'image'
    } else if (/\.(mov|mp4|ogg|webm)$/i.test(fileInput.value)) {
        type = 'video'
    } else if (/\.(pdf)$/i.test(fileInput.value)) {
        type = 'file'
    }
    let customerId = JSON.parse(custom).customerId
    if (customerId) {
        nim.getUser({
            account: customerId,
            sync: true,
            done(error, user) {
                let lang = null
                let content
                if (user && user.custom) {
                    let info = JSON.parse(user.custom)
                    if (info.langCode) {
                        lang = info.langCode
                    }
                }
                if (lang !== null) {
                    if (type === 'image') {
                        content = {
                            'en-TH': '[Pictures]',
                            'th-TH': '[รูปภาพ]',
                        }
                    } else if (type === 'video') {
                        content = {
                            'en-TH': '[Video]',
                            'th-TH': '[วีดีโอ]',
                        }
                    } else if (type === 'file') {
                        content = {
                            'en-TH': '[PDF]',
                            'th-TH': '[PDF]',
                        }
                    }
                    content = content[lang]
                    let payload = {
                        type: custom,
                        value: content,
                    }
                    payload = JSON.stringify(payload)
                    nim.sendCustomSysMsg({
                        scene,
                        to,
                        pushPayload: payload,
                        content: payload,
                        sendToOnlineUsersOnly: false,
                        isPushable: false,
                        apnsText: payload,
                        done: sendCustomSysMsgDone,
                    })
                }
                nim.sendFile({
                    scene,
                    to,
                    type,
                    fileInput,
                    custom,
                    needMsgReceipt,
                    isPushable,
                    needPushNick,
                    pushContent: content || obj.pushContent,

                    uploadprogress(data) {
                        // console.log(data.percentageText)
                    },
                    uploaderror() {
                        fileInput.value = ''
                        console.log('上传失败')
                    },
                    uploaddone(err, file) {
                        fileInput.value = ''
                        // console.log(err);
                        // console.log(file);
                    },
                    beforesend(msg) {
                        // console && console.log('正在发送消息, id=', msg);
                    },
                    done(err, msg) {
                        onSendMsgDone(err, msg)
                    },
                })
            },
        })
    } else {
        nim.sendFile({
            scene,
            to,
            type,
            fileInput,
            custom,
            needMsgReceipt,
            isPushable,
            needPushNick,
            pushContent: obj.pushContent,

            uploadprogress(data) {
                // console.log(data.percentageText)
            },
            uploaderror() {
                fileInput.value = ''
                console.log('上传失败')
            },
            uploaddone(error, file) {
                fileInput.value = ''
                // console.log(error);
                // console.log(file);
            },
            beforesend(msg) {
                // console && console.log('正在发送消息, id=', msg);
            },
            done(error, msg) {
                onSendMsgDone(error, msg)
            },
        })
    }
}

export function sendDropFile({state, commit}, obj) {
    const nim = state.nim
    let {
        scene, to, custom, dataURL, needMsgReceipt, pushContent, isPushable, needPushNick, type,
    } = obj
    if (type.startsWith('image')) {
        type = 'image'
    } else if (type.includes('pdf')) {
        type = 'file'
    }
    let customerId = JSON.parse(custom).customerId
    if (customerId) {
        nim.getUser({
            account: customerId,
            sync: true,
            done(error, user) {
                let lang = null
                let content
                if (user && user.custom) {
                    let info = JSON.parse(user.custom)
                    if (info.langCode) {
                        lang = info.langCode
                    }
                }
                if (lang !== null) {
                    if (type === 'image') {
                        content = {
                            'en-TH': '[Pictures]',
                            'th-TH': '[รูปภาพ]',
                        }
                    } else if (type === 'video') {
                        content = {
                            'en-TH': '[Video]',
                            'th-TH': '[วีดีโอ]',
                        }
                    } else if (type === 'file') {
                        content = {
                            'en-TH': '[PDF]',
                            'th-TH': '[PDF]',
                        }
                    }
                    content = content[lang]
                    let payload = {
                        type: custom,
                        value: content,
                    }
                    payload = JSON.stringify(payload)
                    nim.sendCustomSysMsg({
                        scene,
                        to,
                        pushPayload: payload,
                        content: payload,
                        sendToOnlineUsersOnly: false,
                        isPushable: false,
                        apnsText: payload,
                        done: sendCustomSysMsgDone,
                    })
                }
                nim.sendFile({
                    scene,
                    to,
                    type,
                    dataURL,
                    custom,
                    needMsgReceipt,
                    isPushable,
                    needPushNick,
                    pushContent: content || obj.pushContent,

                    uploadprogress(data) {
                        // console.log(data.percentageText)
                    },
                    uploaderror() {
                        console.log('上传失败')
                    },
                    uploaddone(err, file) {
                    },
                    beforesend(msg) {
                        // console && console.log('正在发送消息, id=', msg);
                    },
                    done(err, msg) {
                        onSendMsgDone(err, msg)
                    },
                })
            },
        })
    } else {
        nim.sendFile({
            scene,
            to,
            type,
            dataURL,
            custom,
            needMsgReceipt,
            isPushable,
            needPushNick,
            pushContent: obj.pushContent,

            uploadprogress(data) {
                // console.log(data.percentageText)
            },
            uploaderror() {
                console.log('上传失败')
            },
            uploaddone(error, file) {
            },
            beforesend(msg) {
                // console && console.log('正在发送消息, id=', msg);
            },
            done(error, msg) {
                onSendMsgDone(error, msg)
            },
        })
    }
}

export function reSendMsg({state, commit}, msg) {
    const nim = state.nim
    nim.resendMsg({
        msg,
        done(error, message) {
            store.commit('chat/replaceMsg', message)
            if (message.sessionId === store.state.chat.currSessionId) {
                store.commit('chat/updateCurrSessionMsgs', {
                    type: 'replace',
                    message,
                })
                // 发送已读回执
                // store.dispatch('chat/sendMsgReceipt')
            }
        },
    })
}

// 发送机器人消息
export function sendRobotMsg({state, commit}, obj) {
    const nim = state.nim
    let {
        type, scene, to, robotAccid, content, params, target, body,
    } = obj
    scene = scene || 'p2p'
    if (type === 'text') {
        nim.sendRobotMsg({
            scene,
            to,
            robotAccid: robotAccid || to,
            content: {
                type: 'text',
                content,
            },
            body,
            done: onSendMsgDone,
        })
    } else if (type === 'welcome') {
        nim.sendRobotMsg({
            scene,
            to,
            robotAccid: robotAccid || to,
            content: {
                type: 'welcome',
            },
            body,
            done: onSendMsgDone,
        })
    } else if (type === 'link') {
        nim.sendRobotMsg({
            scene,
            to,
            robotAccid: robotAccid || to,
            content: {
                type: 'link',
                params,
                target,
            },
            body,
            done: onSendMsgDone,
        })
    }
}

// 发送消息已读回执
export function sendMsgReceipt({state, commit}) {
    // 如果有当前会话
    let currSessionId = store.state.chat.currSessionId
    if (currSessionId) {
        // 只有点对点消息才发已读回执
        if (util.parseSession(currSessionId).scene === 'p2p') {
            const nim = state.nim
            if (state.sessionMap[currSessionId] && state.sessionMap[currSessionId].lastMsg) {
                nim.sendMsgReceipt({
                    msg: state.sessionMap[currSessionId].lastMsg,
                    done: function sendMsgReceiptDone(error, obj) {
                        // do something
                    },
                })
            }
        }
    }
}

// 发送自定义消息
export function sendCustomMsg({state, commit}, obj) {
    const nim = state.nim
    if (obj.data.type) {
        let content = JSON.stringify(obj.data)
        nim.sendCustomMsg({
            scene: obj.scene,
            to: obj.to,
            pushContent: obj.pushContent,
            pushPayload: content,
            content,
            sendToOnlineUsersOnly: false,
            needMsgReceipt: obj.needMsgReceipt || true,
            isPushable: true,
            needPushNick: false,
            apnsText: content,
            custom: obj.custom,
            type: 'custom',
            done: sendCustomSysMsgDone,
        })
    }
}

// 发送表情
export function sendEmojiMsg({state, commit}, obj) {
    const nim = state.nim
    obj = obj || {}
    let type = obj.type || ''
    if (+type === 3) {
        let customerId = JSON.parse(obj.custom).customerId
        let content = {data: {code: obj.emojiNo}, type}
        content = JSON.stringify(content)
        if (customerId) {
            nim.getUser({
                account: customerId,
                sync: true,
                done(error, user) {
                    let lang = null
                    let langContent
                    if (user && user.custom) {
                        let info = JSON.parse(user.custom)
                        if (info.langCode) {
                            lang = info.langCode
                        }
                    }
                    if (lang === null) {
                        lang = 'en-TH'
                    }
                    if (lang !== null) {
                        if (type === '3') {
                            langContent = {
                                'en-TH': '[Sticker]',
                                'th-TH': '[สติ๊กเกอร์]',
                            }
                        }
                        langContent = langContent[lang]
                        nim.sendCustomMsg({
                            scene: obj.scene,
                            to: obj.to,
                            pushPayload: content,
                            pushContent: langContent,
                            content,
                            sendToOnlineUsersOnly: false,
                            needMsgReceipt: obj.needMsgReceipt || true,
                            isPushable: true,
                            needPushNick: false,
                            apnsText: content,
                            custom: obj.custom,
                            type: 'custom',
                            done: sendCustomSysMsgDone,
                        })
                        let push = {
                            type: obj.custom,
                            value: langContent,
                        }
                        push = JSON.stringify(push)
                        nim.sendCustomSysMsg({
                            scene: obj.scene,
                            to: obj.to,
                            pushPayload: push,
                            content: push,
                            sendToOnlineUsersOnly: false,
                            isPushable: false,
                            apnsText: push,
                            done: sendCustomSysMsgDone,
                        })
                    }
                },
            })
        } else {
            nim.sendCustomMsg({
                scene: obj.scene,
                to: obj.to,
                pushPayload: content,
                pushContent: obj.pushContent,
                content,
                sendToOnlineUsersOnly: false,
                needMsgReceipt: obj.needMsgReceipt || true,
                isPushable: true,
                needPushNick: false,
                apnsText: content,
                custom: obj.custom,
                type: 'custom',
                done: sendCustomSysMsgDone,
            })
        }
    }
}

// 发送商品卡片消息
export function sendProductCardMsg({state, commit}, obj) {
    const nim = state.nim
    let {
        scene, to, custom, needMsgReceipt, data, pushContent,
    } = obj
    let customerId = JSON.parse(custom).customerId
    let content = JSON.stringify(data)
    if (customerId) {
        nim.getUser({
            account: customerId,
            sync: true,
            done(error, user) {
                let lang = null
                let langContent = {
                    'en-TH': `Product recommend: ${pushContent}`,
                    'th-TH': `สินค้าแนะนำ: ${pushContent}`,
                }
                if (user && user.custom) {
                    let info = JSON.parse(user.custom)
                    if (info.langCode) {
                        lang = info.langCode
                    }
                }
                if (lang === null) {
                    lang = 'en-TH'
                }
                langContent = langContent[lang]
                nim.sendCustomMsg({
                    scene,
                    to,
                    pushContent: langContent,
                    pushPayload: content,
                    content,
                    sendToOnlineUsersOnly: false,
                    needMsgReceipt: needMsgReceipt || true,
                    isPushable: true,
                    needPushNick: false,
                    apnsText: content,
                    custom,
                    type: 'custom',
                    done: sendCustomSysMsgDone,
                })
                let push = {
                    type: custom,
                    value: langContent,
                }
                push = JSON.stringify(push)
                nim.sendCustomSysMsg({
                    scene,
                    to,
                    pushPayload: push,
                    content: push,
                    sendToOnlineUsersOnly: false,
                    isPushable: false,
                    apnsText: push,
                    done: sendCustomSysMsgDone,
                })
            },
        })
    } else {
        nim.sendCustomMsg({
            scene,
            to,
            pushContent,
            pushPayload: content,
            content,
            sendToOnlineUsersOnly: false,
            needMsgReceipt: needMsgReceipt || true,
            isPushable: true,
            needPushNick: false,
            apnsText: content,
            custom,
            type: 'custom',
            done: sendCustomSysMsgDone,
        })
    }
}

export function getHistoryMsgs({state, commit}, message) {
    const nim = state.nim
    if (nim) {
        let {scene, to} = message
        let options = {
            scene,
            to,
            reverse: false,
            asc: true,
            limit: config.localMsglimit || 20,
            done: function getHistoryMsgsDone(error, obj) {
                if (obj.msgs) {
                    // 历史消息里的 notification 屏蔽
                    if (obj.msgs.length === 0 || (obj.msgs.length === 1 && obj.msgs[0].type === 'notification')) {
                        commit('setNoMoreHistoryMsgs')
                    } else {
                        let msgs = obj.msgs.map(msg => formatMsg(msg))
                        commit('updateCurrSessionMsgs', {
                            type: 'concat',
                            msgs,
                        })
                    }
                }
            },
        }
        if (state.currSessionLastMsg) {
            options = Object.assign(options, {
                lastMsgId: state.currSessionLastMsg.idServer,
                endTime: state.currSessionLastMsg.time,
            })
        }
        nim.getHistoryMsgs(options)
    }
}

export function resetNoMoreHistoryMsgs({commit}) {
    commit('resetNoMoreHistoryMsgs')
}
